import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import { Menu } from "@mui/material";
import { Language } from "@mui/icons-material";
import AddProjectStore from "../../store/AddProjectStore";
import { getContrastTextColor } from "../../Mycomponent/share/components/white-label/helper";

export default function LanguageSelect() {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const curLang = localStorage.getItem("APP_LANG") || "en";
  const open = Boolean(anchorEl);
  const { white_lable } = AddProjectStore((state) => state);

  const countryLanguages = [
    { code: "en", label: "English", flag: "EN" },
    { code: "es", label: "Spanish", flag: "ES" },
    { code: "fr", label: "French", flag: "FR" },
    { code: "de", label: "German", flag: "DE" },
    { code: "it", label: "Italian", flag: "IT" },
    { code: "nl", label: "Dutch", flag: "NL" },
    { code: "pl", label: "Polish", flag: "PL" },
    { code: "sv", label: "Swedish", flag: "SV" },
    { code: "pt", label: "Brasil", flag: "PT" },
    { code: "tr", label: "Turkish", flag: "TR" },
    { code: "vi", label: "Vietnamese", flag: "VI" },
    { code: "zh", label: "Chinese", flag: "ZH" },
    { code: "ja", label: "Japanese", flag: "JA" },
  ];

  const handleUserLanguage = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("APP_LANG", language);
  };

  return (
    <Box
      onMouseEnter={(e) => setAnchorEl(e.currentTarget)}
      onMouseLeave={() => setAnchorEl(null)}
    >
      <div
        style={{
          display: "flex",
          gap: "2px",
          alignItems: "center",
          color: getContrastTextColor(white_lable.theme_color),
        }}
      >
        <Language sx={{ cursor: "default", fontSize: "24px" }} />
        {curLang && (
          <span style={{ fontSize: "14px" }}>{curLang?.toUpperCase()}</span>
        )}
      </div>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          onMouseEnter: () => setAnchorEl(anchorEl),
          onMouseLeave: () => setAnchorEl(null),
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {countryLanguages.map((item, index) => (
          <MenuItem
            key={index}
            className={curLang === item.code ? "current-language" : "normal"}
            onClick={() => handleUserLanguage(item.code)}
            value={item.code.toLocaleUpperCase()}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
